import React from "react";
import { nombreTipoCierre } from "../../../../helpers/tiposCierreMensual";

// Pie de la pantalla, con el mismo orden del formato impreso: las observaciones
// van después de la tabla y la acción cierra la hoja. Cada cierre guarda las
// suyas, así que el completo muestra un cuadro por tipo; en el Excel se imprimen
// juntas, en el mismo espacio del formato
export const PieCierreMensual = ({ cierreMensual, onRegistrar }) => {
    const { puedeCerrar, tiposIncluidos, observaciones } = cierreMensual;

    if (!puedeCerrar) {
        return null;
    }

    const variosTipos = tiposIncluidos.length > 1;

    return (
        <div className="mt-4">
            <div className="row">
                {tiposIncluidos.map((tipoCierre) => (
                    <div
                        key={tipoCierre}
                        className={variosTipos ? "col-12 col-md-6" : "col-12"}
                    >
                        <label className="formulario-field__label">
                            {variosTipos
                                ? "Observaciones de " +
                                  nombreTipoCierre(tipoCierre).toLowerCase()
                                : "Observaciones"}
                        </label>
                        <textarea
                            style={{ resize: "none" }}
                            rows={3}
                            className="form-control"
                            placeholder="Opcional. Se imprimen en el pie del reporte"
                            value={observaciones[tipoCierre] || ""}
                            onChange={(e) =>
                                cierreMensual.CambiarObservaciones(
                                    tipoCierre,
                                    e.target.value,
                                )
                            }
                        />
                    </div>
                ))}
            </div>

            <div className="d-flex justify-content-center align-items-center flex-wrap gap-1rem my-4">
                <button
                    className="btn btn-primary text-nowrap"
                    onClick={onRegistrar}
                >
                    Generar reporte
                </button>
            </div>
        </div>
    );
};
